






import Component from 'vue-class-component';
import { FormContainer } from '@/common/mixin/FormContainer';
import SensorCreateForm from '@/context/sensor/component/form/SensorCreateForm.vue';
import WorkPeriodTemplateForm
  from '@/context/work_period/component/template-form/WorkPeriodTemplateForm.vue';
import { WorkPeriodTemplate } from '@/context/work_period/model/WorkPeriodTemplate';
import { WorkPeriodApi } from '@/context/work_period/api/WorkPeriodApi';

@Component({
  components: {
    WorkPeriodTemplateForm,
    SensorCreateForm
  }
})
export default class WorkPeriodFormContainer extends FormContainer<WorkPeriodTemplate> {
  model: WorkPeriodTemplate = new WorkPeriodTemplate();

  async formApi(): Promise<WorkPeriodTemplate> {
    const instance = WorkPeriodApi.instance();
    console.log(instance);
    const bl = await instance.form<WorkPeriodTemplate>(
      WorkPeriodTemplate,
      this.$route?.params?.id ? { id: this.$route.params.id } : { }
    );
    console.log(bl);
    return bl;
  }
}
